import { BlockStack } from "@shopify/polaris";
import React from "react";
import { formatParagraph } from "../../functions/formatParagraph";
import { Text } from "../tailwind/text";
import { ButtonsPreview } from "./ButtonsPreview";
import { FooterPreview } from "./FooterPreview";
import { HeaderPreview } from "./HeaderPreview";
import { LimitedTimeOfferPreview } from "./LimitedTimeOfferPreview";
import "./template-preview.css";
import Carousel from "./Carousel";

export const TemplatePreview = ({
  selectedHeader,
  limitedTimeOffer,
  isLimitedTimeOffer,
  body,
  footer,
  copyCodeButton,
  quickReply1,
  quickReply2,
  quickReply3,
  urlButton,
  urlButton2,
  width,
  imageMaxHeight,
  imageUrl,
  videoUrl,
  isUrlButtonAtBottom = true,
  isInPanel,
  cards,
  isInConversation,
}) => {
  const _selectedHeaderType = selectedHeader?.toLowerCase();
  const _selectedCardsHeader = cards ? cards[0].components.find((c) => c.type === "HEADER").format : null;

  const _header = {
    selectedHeaderType: _selectedHeaderType,
    imageMaxHeight,
    imageUrl,
    videoUrl,
  };

  const buttonsMap = new Map();

  if (copyCodeButton) {
    buttonsMap.set("copyCodeButton", copyCodeButton);
  }
  if (quickReply1) {
    buttonsMap.set("quickReply1", quickReply1);
  }
  if (quickReply2) {
    buttonsMap.set("quickReply2", quickReply2);
  }
  if (quickReply3) {
    buttonsMap.set("quickReply3", quickReply3);
  }
  if (urlButton) {
    buttonsMap.set("urlButton", urlButton);
  }
  if (urlButton2) {
    buttonsMap.set("urlButton2", urlButton2);
  }
  if (isUrlButtonAtBottom) {
    buttonsMap.set("isUrlButtonAtBottom", isUrlButtonAtBottom);
  }

  const _hasHeaderMedia = ["image", "video"].includes(_selectedHeaderType);

  const cardsItems = [];

  if (cards) {
    cards.forEach((card, index) => {
      let headerLink = null;
      let body = "";
      let buttons = [];
  
      card.components.forEach((component) => {
        if (component.type === "HEADER") {
          headerLink = component.link || null;
        }
        if (component.type === "BODY") {
          body = component.text || "";
        }
        if (component.type === "BUTTONS") {
          buttons = component.buttons.map((btn) => ({
            type: btn.type.toLowerCase(),
            text: btn.text,
          }));
        }
      });
  
      cardsItems.push({
        id: index + 1, 
        headerLink,
        body,
        buttons,
      });
    });
  }
  
  return (
    <BlockStack>
      <div style={{ width }} className="flex flex-col items-center justify-center">
        <div className={isInConversation ? "" : "template-preview"} style={{width: !cards ? "100%" : isInConversation ? "100%" : "350px"}}>
          {_hasHeaderMedia && <HeaderPreview header={_header} />}
          {isLimitedTimeOffer && (
            <LimitedTimeOfferPreview
              headerMedia={{ type: _selectedHeaderType }}
              limitedTimeOffer={limitedTimeOffer}
              copyCodeButton={buttonsMap.get("copyCodeButton")}
              isInPanel={isInPanel}
            />
          )}

          <BlockStack gap="3" >
            {formatParagraph(body).map((formattedLine, index) => (
              <Text as="div" key={index} >
                {formattedLine}
              </Text>
            ))}
          </BlockStack>

          {footer && <FooterPreview className="footer" footer={footer} />}
        </div>

          {cards && (
            <div className="w-full mt-3 flex items-center justify-center">
              <Carousel
                baseWidth={window.innerWidth < 1040 ? 230 : 350}
                autoplay={false}
                autoplayDelay={3000}
                pauseOnHover={true}
                loop={true}
                round={false}
                headerType={_selectedCardsHeader}
                items={cardsItems}
              />
            </div>
          )}
        <ButtonsPreview buttonsMap={buttonsMap} />
      </div>
    </BlockStack>
  );
};
